<template>
  <div id="app">
    <router-view/>
    <notifications group="global" position="bottom right"/>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
var head = document.getElementsByTagName( 'head' )[0]

var insertBefore = head.insertBefore

head.insertBefore = function( newElement, referenceElement ) {

    if ( newElement.href && newElement.href.indexOf( 'https://fonts.googleapis.com/css?family=Roboto' ) === 0 ) {
        return
    }

    insertBefore.call( head, newElement, referenceElement )
}

// export default {
//   data() {
//     return {
//       isBlocked: this.getCookie('beInternet'),
//     }
//   },methods: {
//   getCookie(cname){
//     let name = cname + "=";
//     let decodedCookie = decodeURIComponent(document.cookie);
//     let ca = decodedCookie.split(';');
//     for(let i = 0; i <ca.length; i++) {
//       let c = ca[i];
//       while (c.charAt(0) == ' ') {
//         c = c.substring(1);
//       }
//       if (c.indexOf(name) == 0) {
//         return false;
//       }
//     }
//     return true;
//   }
// }
// }
</script>